import { Typography } from '@mui/material';
import { Box } from '@mui/system';
import React from 'react';

const StatusCodesApiList = () => {
    return (
        <Box sx={{ marginBottom: 2 }}>
            <Typography
                variant="body2"
                fontWeight={600}
                fontSize={15}
                sx={{ 
                    textDecoration: 'underline', 
                    cursor: 'pointer',
                    color: '#374151',
                    '&:hover': {
                        color: '#1f2937',
                        textDecoration: 'underline'
                    }
                }}
                onClick={() => {
                    const statusCodesElement = document.getElementById("status-codes");
                    if (statusCodesElement) {
                        statusCodesElement.scrollIntoView({ behavior: "smooth", block: "start" });
                    }
                }}
            >
                Status Codes
            </Typography>
        </Box>
    );
};

export default StatusCodesApiList;
